'use client'

import { signOut as signOutNexAuth, useSession } from 'next-auth/react'

import configuration from '~/configuration'
import useMiddlewareRequest from '~/core/middleware/use-middleware-request'

import { useRouterContext } from '~/lib/next/use-router-context'
import useBoundStore from '~/lib/store'

export function useSubmitSignOutCHUB() {
  const { params, locale } = useRouterContext()
  const { data: session } = useSession()
  const { user } = useBoundStore()
  const { trigger, isMutating, data, error } = useMiddlewareRequest({
    endpoint: configuration.path.careerHub.signOut(params?.slug as string),
    method: 'POST',
    locale
  })

  const handleSignOut = async () => {
    trigger({}).then(async (result) => {
      if (result.success) {
        if (session) {
          await signOutNexAuth({ redirect: false })
        }

        // FIXED: Redirect to user's actual tenant login, not URL tenant
        const redirectSlug = user?.currentTenant?.slug || (params?.slug as string)
        window.location.href = configuration.path.careerHub.login(redirectSlug)
      }
    })
  }

  return {
    handleSignOut,
    isLoading: isMutating,
    data,
    error
  }
}
